export default "__VITE_ASSET__eimxsujl__"